export const TIPO_NUMERACION = {
  NUMERO: 1,
  SIN_NUMERO: 2,
  KILOMETRO: 3,
  OTROS: 4,
} as const

export type TipoNumeracionType =
  (typeof TIPO_NUMERACION)[keyof typeof TIPO_NUMERACION]
